import { LanguageCode } from '@sparted/shared-library/business/types';
import { fetchFactory } from 'Libs/http/utils';

import type { DuplicateBreakingNewsId, DuplicateCampaignId } from './activity.type';

export const duplicateBreakingNews = async (breakingNewsId: number, boLanguageCode?: LanguageCode) => {
  const { fetchFn } = fetchFactory<DuplicateBreakingNewsId>({
    route: `/api/breaking-news/duplicate`,
    method: 'POST',
    payload: {
      breakingNewsId,
      boLanguageCode,
    },
  });

  return fetchFn();
};

export const duplicateCampaign = async (campaignId: number, boLanguageCode?: LanguageCode) => {
  const { fetchFn } = fetchFactory<DuplicateCampaignId>({
    route: `/api/campaigns/duplicate`,
    method: 'POST',
    payload: {
      campaignId,
      boLanguageCode,
    },
  });

  return fetchFn();
};
